import ToggleSwitch from "./ToggleSwitch";

export { ToggleSwitch };

export default ToggleSwitch;
